export default __webpack_public_path__ + "static/ring-size-chart-mobile-42afa674ba382b565a78d6f9bd19c16e.jpg";